module.exports = __webpack_public_path__ + "static/media/sopt9kz.3d7f860e.pdf";